if ( typeof jQuery !== 'undefined' ) {

    jQuery.fn.extend({
        scrollTo: function( urlString, offset, speed ) {

            if ( typeof urlString === 'undefined' || ! urlString ) {
                return false;
            }

            if ( urlString == '#top' ) {
                scrollTo( '#hdr', null, 300 );
                return false;
            }

            if ( typeof offset !== 'number' ) {
                offset = 0;
            }

            if ( typeof speed !== 'number' ) {
                speed = 0;
            }

            var hashName = urlString.split('#')[1];

            if ( hashName ) {

                var element = jQuery( '#' + hashName + ', [name="' + hashName + '"]' ).eq(0);

                if ( element.length ) {

                    jQuery('html, body').animate({
                        scrollTop: element.offset().top - offset
                    }, speed );
                }
            }

            return this;
        }
    });
}